<template>
  <div>
    <b-carousel
      id="news-carousel"
      v-model="slide"
      :interval="4000"
      :controls="enableControls"
      background="#ababab"
      img-width="1024"
      img-height="480"
    >
      <b-carousel-slide
        v-for="(newsSlide, i) in items"
        :key="'newsCarouselSlide' + i"
      >
        <b-row>
          <b-col v-for="(newsItem, i) in newsSlide" :key="`New ${i}`">
            <b-card
              :sub-title="newsItem.title"
              :img-src="newsItem.image"
              :img-alt="`New ${i}`"
              img-top
              tag="article"
              class="smooth-shadow text-left"
            >
              <!--<b-card-text>-->
              <!--{{ person.description }}-->
              <!--</b-card-text>-->
              <b-link
                @click="$router.push(`entrada/${newsItem.id}`)"
                class="card-link color-base color-hover d-block mt-4 text-right"
              >
                Leer más →
              </b-link>
            </b-card>
          </b-col>
        </b-row>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { checkIsMobile } from "@/utils/checkIsMobile.js";

export default {
  name: "newsCarousel",
  props: {
    news: Array
  },
  data() {
    return {
      slide: 0
    };
  },
  computed: {
    items: function () {
      const tmpArr = [];
      let arrCounter = 0;
      let isMobile = checkIsMobile();

      if (!isMobile) {
        tmpArr.push([]);

        for (let i = 0; i < this.news.length; i++) {
          if (i > 0 && i % 3 === 0) {
            arrCounter = ++arrCounter;
            tmpArr.push([]);
          }
          tmpArr[arrCounter].push(this.news[i]);
        }
        return tmpArr;
      } else {
        this.news.forEach((item) => {
          tmpArr.push([item]);
        });
        return tmpArr;
      }
    },
    enableControls: function () {
      let tmpItems = this.items.flat();
      if (tmpItems && tmpItems.length <= 3) return false;
      return true;
    }
  }
};
</script>

<style lang="sass">
#news-carousel
  background: transparent !important
  .carousel
    &-inner
      width: 90%
      margin: 0 auto 3rem
    &-caption
      position: relative
      display: flex
      flex-direction: row
      justify-content: space-between
      color: inherit
      left: 0
      right: 0
      bottom: 0
      padding: 0
      margin: 1rem 2rem 2rem
    &-item
      background: transparent !important
      .card
        border-radius: 0
        border: 0
        box-shadow: 0 12px 24px 0 rgba(#818979, 0.16)
        &:hover, &:active
          box-shadow: 0 10px 20px -8px rgba(#818979, 0.32)
        &-img-top
          border-radius: 0
          filter: sepia(1) hue-rotate(45deg) brightness(0.8) contrast(0.7) opacity(0.9) grayscale(0.3);
    &-control-prev
      justify-content: flex-start
      width: 10%
      &-icon
        width: 40px
        height: 40px
        // eslint-disable-next-line
        background-image: url('~@/assets/slider-nav-arrow.svg')
    &-control-next
      justify-content: flex-end
      width: 10%
      &-icon
        width: 40px
        height: 40px
        // eslint-disable-next-line
        background-image: url('~@/assets/slider-nav-arrow.svg')
        transform: rotate(180deg)
    &-indicators
      margin: 0
      bottom: -3rem
      li
        outline: none
        background-color: #ACB7A1
        width: 1rem
        height: 1rem
        border-radius: 50%
        margin: 0 0.5rem
</style>
